import api from '@/auth/api';
import { alertSuccess, alertError } from '@/components/Alert';
import React, { useState } from 'react';

function Add({onSuccess}) {
  const [title, setTitle] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const response = await api.post('/PanelHome/panel/spamType',{title})
        alertSuccess(response.data.success);
        onSuccess()
    } catch (error) {
      console.error('Error:', error);
      alertError(error.response.data.errors);
    }
  };

  return (
    <form
      onSubmit={handleSubmit}
      className='flex items-center flex-col gap-4 p-4'
    >
      <input
        type='text'
        placeholder='Enter title'
        required
        value={title}
        onChange={(e) => setTitle(e.target.value)}
        className='border p-2 rounded w-full max-w-sm'
      />
      <button type='submit' className='activeBtn rounded-sm w-fit text-white p-2'>
        Submit
      </button>
    </form>
  );
}

export default Add;
